import { createContext, useContext } from 'react'

import { validateContext } from 'shared/utils'

export const SelectedSectionsStateContext = createContext({})
export const SelectedSectionsActionsContext = createContext({})

export const useSelectedSectionsState = () => validateContext(useContext(SelectedSectionsStateContext), {
  contextName: 'SelectedSectionsStateContext',
  providerName: 'SelectedSectionsProvider'
})

export const useSelectedSectionsActions = () => validateContext(useContext(SelectedSectionsActionsContext), {
  contextName: 'SelectedSectionsActionsContext',
  providerName: 'SelectedSectionsProvider'
})

export const useSelectedSections = () => {
  const state = useSelectedSectionsState()
  const actions = useSelectedSectionsActions()

  return {
    ...state,
    ...actions
  }
}
